import { render, staticRenderFns } from "./CategoriesCompactList.vue?vue&type=template&id=5de21dee&scoped=true"
import script from "./CategoriesCompactList.vue?vue&type=script&lang=js"
export * from "./CategoriesCompactList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de21dee",
  null
  
)

export default component.exports